import React from "react";
const axios = require('axios');

import EDW_CONST from '../constants';

const getRequestOption = (endPoint, urlParams, token) => {

    let url = EDW_CONST.API_DOMAIN + endPoint + '/' + EDW_CONST.API_ORGANIZATOIN + '/' + EDW_CONST.PRODUCT_MODEL_REGION + '/' + urlParams;

    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'apiKey': EDW_CONST.API_KEY,

        
        // 'Strict-Transport-Security':'max-age=31536000',
        // 'X-Frame-Options': 'SAMEORIGIN',
        // 'X-DNS-Prefetch-Control': 'on',
        // 'X-Content-Type-Options': 'nosniff',
        // 'X-XSS-Protection': '1',
        //  'X-Download-Options': 'noopen',
        // 'Content-Security-Policy': 'self'
    };
    
    let edwData = JSON.parse(localStorage.getItem('edwData'));

    if (edwData && edwData.edwSId != null && edwData.edwUId != null) {
        headers['impersonateOrgId'] = edwData.edwSId;
        headers['impersonateUserId'] = edwData.edwUId;
    }

    let option = {
        method: 'get',
        url: url,
        data: null,
        headers: headers,
        timeout: 10000,
        responseType: 'json'
    }

    return option;

}


const asyncCallHandler = (endPoint, urlParams, token) => {
    let option = getRequestOption(endPoint, urlParams, token);
    return axios(option);
}

export default asyncCallHandler;
